"use client";
import * as React from "react";
const SvgWifiOutlined = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 12", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "m0 3.51 1.46 1.55a8.9 8.9 0 0 1 13.09 0L16 3.5a10.87 10.87 0 0 0-16 0m5.82 6.2L8 12l2.18-2.31a2.96 2.96 0 0 0-4.36 0M2.9 6.6l1.46 1.54a4.94 4.94 0 0 1 7.27 0l1.45-1.54a6.9 6.9 0 0 0-10.18 0" }));
export {
  SvgWifiOutlined as default
};
